export default "__VITE_ASSET__CX_GEN01__"